interface LoginFormProps {
  email: string;
  setEmail: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  error?: string | null;
}

export const LoginForm = ({
  email,
  setEmail,
  password,
  setPassword,
  onSubmit,
  error,
}: LoginFormProps) => {
  return (
    <form onSubmit={onSubmit} style={styles.form}>
      <div style={styles.inputField}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={styles.input}
          required
        />
      </div>

      <div style={styles.inputField}>
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          style={styles.input}
          required
        />
      </div>

      {error && (
        <p role="alert" style={styles.error}>
          {error}
        </p>
      )}

      <button type="submit" style={styles.button}>
        Sign In
      </button>
    </form>
  );
};

const styles: {[key: string]: React.CSSProperties} = {
  form: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '10px',
    width: '100%',
  },
  error: {
    color: '#ff4d4d',
    margin: '4px 0',
    fontSize: '14px',
  },
  inputField: {
    backgroundColor: '#373737',
    width: '100%',
    boxSizing: 'border-box',
  },
  input: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#fff',
    fontSize: '15px',
    outline: 'none',
    width: '100%',
    padding: '15px 15px',
    boxSizing: 'border-box',
    display: 'block',
  },
  button: {
    backgroundColor: '#E4FD08',
    color: '#000',
    padding: '15px',
    border: 'none',
    fontSize: '15px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
};
